import { themeHelpers } from '@gotamedia/fluffy/theme';
import styled, { css } from 'styled-components';
const Footer = styled.div.withConfig({
  displayName: "style__Footer",
  componentId: "sc-vereg8-0"
})(["display:flex;padding:40px 64px;flex-direction:column;align-items:center;gap:40px;background:#2E2A25;width:100%;margin-top:auto;", " @media screen and (max-width:1300px){flex-direction:column;padding:32px 16px;align-items:flex-start;}"], themeHelpers.isNotLargeDevice(css(["flex-direction:column;align-items:flex-start;padding:32px 16px;"])));
const FooterColumnWrapper = styled.div.withConfig({
  displayName: "style__FooterColumnWrapper",
  componentId: "sc-vereg8-1"
})(["display:flex;align-items:flex-start;gap:280px;max-width:1600px;", " @media screen and (max-width:1300px){max-width:744px;flex-direction:column;gap:48px;}", ""], themeHelpers.isMediumDevice(css(["max-width:747px;flex-wrap:wrap;gap:157px;"])), themeHelpers.isNotLargeDevice(css(["gap:48px;max-width:375px;flex-direction:column;gap:70px;"])));
const Flex = styled.span.withConfig({
  displayName: "style__Flex",
  componentId: "sc-vereg8-2"
})(["max-width:1600px;width:100%;"]);
const FlexColumn = styled.div.withConfig({
  displayName: "style__FlexColumn",
  componentId: "sc-vereg8-3"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:24px;flex:1 1 0;", " ", " @media screen and (max-width:1300px){width:100%;}"], themeHelpers.isMediumDevice(css(["width:100%;"])), themeHelpers.isSmallDevice(css(["flex-direction:column;padding-bottom:0;"])));
const FlexRow = styled.div.withConfig({
  displayName: "style__FlexRow",
  componentId: "sc-vereg8-4"
})(["display:block;", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;"])));
const Section = styled.div.withConfig({
  displayName: "style__Section",
  componentId: "sc-vereg8-5"
})(["display:flex;flex-direction:column;"]);
const BoldText = styled.p.withConfig({
  displayName: "style__BoldText",
  componentId: "sc-vereg8-6"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:700;line-height:20px;margin-right:2px;display:inline;color:#DADAD8;"]);
const Text = styled.p.withConfig({
  displayName: "style__Text",
  componentId: "sc-vereg8-7"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;display:inline;color:", ";"], ({
  theme
}) => theme.colors.grey[3]);
const Headline = styled.h2.withConfig({
  displayName: "style__Headline",
  componentId: "sc-vereg8-8"
})(["font-family:'Sanomat Sans Text';font-weight:700;font-size:14px;line-height:18px;white-space:pre-line;margin-right:2px;color:", ";"], ({
  theme
}) => theme.colors.grey[4]);
const SocialMediaWrapper = styled.div.withConfig({
  displayName: "style__SocialMediaWrapper",
  componentId: "sc-vereg8-9"
})(["display:flex;flex:1 1 0;gap:32px;margin-top:10px;"]);
const AppsWrapper = styled.div.withConfig({
  displayName: "style__AppsWrapper",
  componentId: "sc-vereg8-10"
})([""]);
const SocialMediaLink = styled.a.withConfig({
  displayName: "style__SocialMediaLink",
  componentId: "sc-vereg8-11"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;text-decoration:none;color:", ";display:flex;flex-direction:column;align-items:center;gap:8px;&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.colors.grey[3]);
const Link = styled.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-vereg8-12"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;text-decoration:none;color:", ";&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.colors.grey[3]);
const IconWrapper = styled.div.withConfig({
  displayName: "style__IconWrapper",
  componentId: "sc-vereg8-13"
})([""]);
const SocialMediaIcon = styled.img.withConfig({
  displayName: "style__SocialMediaIcon",
  componentId: "sc-vereg8-14"
})([""]);
export { Footer, FooterColumnWrapper, Flex, FlexColumn, FlexRow, Section, Text, BoldText, Headline, SocialMediaWrapper, SocialMediaLink, AppsWrapper, IconWrapper, SocialMediaIcon, Link };